// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3RnkC","input":"styles_input__5R_uJ"};